import FxPromise from './Promise';
import FxHttp from './Http';

export default class Fx
{
    static Promise = FxPromise;
    static Http = FxHttp;
    static $globalVue = null;

    static mergeDeep()
    {
        var target = null, isArrayTarget, lastValue = null;
        var arg, k, v;
        // console.log(arguments);

        for(var i = 0, l = arguments.length; i < l; ++i)
        {
            arg = arguments[i];
            if(arg === null || typeof arg != "object")
            {
                lastValue = arg;
                continue;
            }

            if(!target)
            {
                isArrayTarget = Fx.isArray(arg);
                target = isArrayTarget ? [] : {};
            }

            if(isArrayTarget && Fx.isArray(arg))
            {
                // target = target.concat(arg);
                for(var j = 0, jl = arg.length; j < jl; ++j)
                    target.push((arg[j] && typeof (arg[j]) == "object") ? Fx.mergeDeep(arg[j]) : arg[j]);

                continue;
            }

            for(k in arg)
            {
                v = arg[k];
                if(v && typeof (v) == "object")
                    target[k] = Fx.mergeDeep(target[k], arg[k]);
                else
                    target[k] = v;
            }
        }

        return target || lastValue;
    }

    static isArray(arr)
    {
        if(!arr)
            return false;
        //为了兼容mobx的数组observable对象
        if(arr.peek && (typeof arr.peek == "function"))
        {
            return Array.isArray(arr.peek());
        } else
        {
            return Array.isArray(arr);
        }
    }

    static generateId = (() =>
    {
        var idSerialNumber = 0,
            idVersion = 0,
            idVersionNumberLength = 1, idVersionNumberExp = Math.pow(10, idVersionNumberLength),
            idSerialNumberLenght = 3, idSerialNumberExp = Math.pow(10, idSerialNumberLenght),
            idRandomNumberLength = 3, idRandomNumberExp = Math.pow(10, idRandomNumberLength),
            idMaxLength = 16, idMaxExp = Math.pow(10, idMaxLength),
            lastIds = [];
        return (userId) =>
        {
            var id;
            while(lastIds.indexOf(id = generate()) >= 0)
                console.warn("id duplicate:", id, lastIds.indexOf(id), lastIds.length);

            while(lastIds.length >= idSerialNumberExp * 2)
                lastIds.shift();

            lastIds.push(id);
            // console.log("id:", id);
            return id;

            function generate()
            {
                var random = 0; //随机数更有可能生产不可检测(lastIds)的重复id
                // var random = Math.ceil(r>0 ? r : Math.random() * idRandomNumberExp) % idRandomNumberExp;
                var mt = (new Date()).getTime(); //microTime
                var id = random * idSerialNumberExp * idVersionNumberExp * 100;
                // id += Math.ceil(((random||0) % 1000000000) / 1000000) * 100000000000; //UserId[10:13]*(10^10)
                id += (mt * idSerialNumberExp * idVersionNumberExp) % idMaxExp;
                id += ((idSerialNumber++) % idSerialNumberExp) * idVersionNumberExp;
                id += idVersion;
                return id;
            }
        }
    })();

    static time()
    {
        return Math.floor((new Date()).getTime() / 1000);
    }

    static msTime()
    {
        return (new Date()).getTime();
    }

    static moneyFormat(money, seperator = ',', precision = 2)
    {
        if(typeof money != 'number') console.warn('money type should be number!');
        if(precision < 0)
        {
            console.warn('min precision is 0!');
            precision = 2;
        }

        const moneyStr = `${money}`.trim();
        const arr = moneyStr.split('.');
        let left = arr[0];
        let right = arr[1] || '';

        let result = '';
        for(let length = left.length, i = length - 1, j = 1; i >= 0; i--, j++)
        {
            if(j % 3 === 0 && j !== length) result = seperator + left[i] + result;
            else result = left[i] + result;
        }

        if(right.length == precision)
        {
            //
        } else if(right.length < precision)
        {
            right += '0'.repeat(precision - right.length)
        } else
        {
            right = right.substr(0, precision);
        }
        return result + (precision > 0 ? '.' + right : right);
    }

    static isPhone(phone)
    {
        const newPhone = (`${phone}`.match(/\d+/g) || []).join('');
        return newPhone.length === 11 && newPhone[0] == 1;
    }

    static isEmail(email)
    {
        const re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        return re.test(email);
    }

}



// WEBPACK FOOTER //
// ./src/fx/Fx.js